export enum SessionCookieVariation {
  KITS = 'kits',
  ARPEGGI = 'arpeggi'
}

export interface DecodedSessionCookie {
  nonce: string
  signature: string
  wallet_address: string
  variation?: SessionCookieVariation
}
